interface UnitOptionsProps {
  defaultUnit?: string;
  units: ReadonlyArray<string>;
}

export const UnitOptions = ({ units, defaultUnit }: UnitOptionsProps) => {
  if (units.length > 0) {
    return (
      <>
        {units.map(unitOption => (
          <option key={unitOption} value={unitOption}>
            {unitOption}
          </option>
        ))}
      </>
    );
  }
  if (defaultUnit) {
    return <option value={defaultUnit}>{defaultUnit}</option>;
  }
  return null;
};
